export default {"src":"/_next/static/media/minidiftman-smile.b33bb080.svg","height":73,"width":73,"blurWidth":0,"blurHeight":0};